<aside
  class="vd-sidebar"
  [class.collapsed]="collapsed()"
  [style.width]="width()"
  role="navigation"
  [attr.aria-label]="'sidebar.aria_label' | transloco"
>
  <div class="sidebar-scroll">
    <ng-container *ngFor="let group of groups()">
      <div class="nav-group">
        <span class="group-title" *ngIf="!collapsed()">{{ group.title | transloco }}</span>

        <ul class="nav-list">
          <li *ngFor="let item of group.items" class="nav-li">

            <!-- Lien simple -->
            <a
              *ngIf="item.route && !item.children"
              [routerLink]="item.route"
              class="nav-item"
              [class.active]="isActive(item)"
              [title]="item.label | transloco"
            >
              <span class="nav-icon material-icons-outlined">{{ item.icon }}</span>
              <span class="nav-label">{{ item.label | transloco }}</span>
              <span class="nav-badge" *ngIf="item.badge && !collapsed()">{{ item.badge }}</span>
              <span class="nav-tooltip" *ngIf="collapsed()">{{ item.label | transloco }}</span>
            </a>

            <!-- Groupe avec enfants -->
            <ng-container *ngIf="item.children">
              <button
                type="button"
                class="nav-item nav-toggle"
                [class.active]="isActive(item)"
                (click)="toggleGroup(item.label)"
                [attr.aria-expanded]="isGroupExpanded(item.label)"
                [title]="item.label | transloco"
              >
                <span class="nav-icon material-icons-outlined">{{ item.icon }}</span>
                <span class="nav-label">{{ item.label | transloco }}</span>
                <span
                  *ngIf="!collapsed()"
                  class="nav-chevron material-icons-outlined"
                  [class.rotated]="isGroupExpanded(item.label)"
                >chevron_right</span>
                <span class="nav-tooltip" *ngIf="collapsed()">{{ item.label | transloco }}</span>
              </button>

              <ul
                class="nav-sublist"
                *ngIf="!collapsed() && isGroupExpanded(item.label)"
              >
                <li *ngFor="let child of item.children">
                  <a
                    [routerLink]="child.route"
                    class="nav-item nav-subitem"
                    [class.active]="isActive(child)"
                  >
                    <span class="nav-icon material-icons-outlined">{{ child.icon }}</span>
                    <span class="nav-label">{{ child.label | transloco }}</span>
                    <span
                      class="nav-badge nav-badge-soon"
                      *ngIf="child.badge"
                    >{{ child.badge | transloco }}</span>
                  </a>
                </li>
              </ul>
            </ng-container>
          </li>
        </ul>
      </div>
    </ng-container>
  </div>

  <!-- Pied de sidebar : collapse toggle -->
  <button
    type="button"
    class="collapse-btn"
    (click)="toggleCollapse()"
    [title]="(collapsed() ? 'sidebar.expand' : 'sidebar.collapse') | transloco"
    [attr.aria-label]="(collapsed() ? 'sidebar.expand' : 'sidebar.collapse') | transloco"
  >
    <span class="material-icons-outlined">{{ collapsed() ? 'chevron_right' : 'chevron_left' }}</span>
    <span *ngIf="!collapsed()" class="collapse-label">{{ 'sidebar.collapse_short' | transloco }}</span>
  </button>
</aside>
